import mongoose, { Schema, Model } from 'mongoose';
import { IAttachment, AttachmentType, EntityModel } from '../interfaces/attcahment.interface';

const AttachmentSchema = new Schema<IAttachment>(
    {
        type: {
            type: String,
            enum: Object.values(AttachmentType),
            required: true,
        },
        mimetype: {
            type: String,
            required: true,
        },
        key: {
            type: String,
            required: true,
        },
        thumbnailKey: {
            type: String,
            require: false
        },
        filename: {
            type: String,
            required: true,
        },
        fileSize: {
            type: Number,
            required: true,
        },
        uploadedBy: {
            type: Schema.Types.ObjectId,
            ref: 'User',
            required: true,
        },
        isTemporary: {
            type: Boolean,
            default: false,
        },
        moduleType: {
            type: String,
            enum: Object.values(AttachmentType),
            required: true,
        },
        entityId: {
            type: Schema.Types.ObjectId,
            refPath: 'User'
        },
        entityModel: {
            type: String,
            enum: Object.values(EntityModel),
            required: true,
        },
        metadata: {
            type: Schema.Types.Mixed,
            default: {},

        },
        isDeleted: { type: Boolean, default: false },
        deletedAt: { type: Date, default: null }
    },
    {
        timestamps: { createdAt: true, updatedAt: false },
        versionKey: false
    }
);

const Attachment: Model<IAttachment> = mongoose.model<IAttachment>('Attachment', AttachmentSchema);
export default Attachment;